import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * WOLF-3247 (D10) — release flag of the treasury circuit v2, read from the small endpoint that is
 * open to any authenticated user (the Configuracion routes are admin-only). Off until loaded and on
 * any error, so an older API without the endpoint keeps the current Préstamos screen.
 */
@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private http = inject(HttpClient);
  private url = `${environment.apiUrl}/feature-flags/tesoreria-circuito-v2`;
  private _tesoreriaCircuitoV2 = signal(false);
  private ready: Promise<boolean> | null = null;

  tesoreriaCircuitoV2 = this._tesoreriaCircuitoV2.asReadonly();

  load(): void {
    void this.whenLoaded();
  }

  /**
   * Starts the single load (idempotent) and resolves with the flag once the API answered; on any
   * error it resolves false. Route guards await it so a redirect never depends on a still-unknown flag.
   */
  whenLoaded(): Promise<boolean> {
    if (!this.ready) {
      this.ready = new Promise<boolean>((resolve) => {
        this.http.get<{ enabled: boolean }>(this.url).subscribe({
          next: (res) => {
            this._tesoreriaCircuitoV2.set(res?.enabled === true);
            resolve(this._tesoreriaCircuitoV2());
          },
          error: () => {
            this._tesoreriaCircuitoV2.set(false);
            // Keep false for this read only: clearing the cache lets the next load() retry, so a
            // transient failure does not pin the flag off for the whole session.
            this.ready = null;
            resolve(false);
          },
        });
      });
    }
    return this.ready;
  }
}
